<template>
  <canvas :height="height" :width="width" id="financements-percus-total-par-stade-graph"></canvas>
</template>
<script>
import {SOLUTIA} from "@/constants/Colors";
import {Chart} from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {arrondirKeuros, arrondirKeurosAsNumber} from "@/util";

export default {
  name: "FinancementsPercusTotauxParStadeGraph",
  props: {
    data: Array,
    height: {
      type: Number,
      default: 600,
    },
    width: {
      type: Number,
      default: 600,
    }
  },
  mounted: async function () {
    let statusFetchStatus = this.$store.getters["dossier/statuts/statut_fetch_status"];
    if (statusFetchStatus === "INITIAL" || statusFetchStatus === "ERROR") {
      await this.$store.dispatch("dossier/statuts/getStatuts");
    }
    // eslint-disable-next-line no-unused-vars
    this.data.map(data_of_year => {
      console.log(`${arrondirKeuros(data_of_year.total_percu)} - ${data_of_year.year}`);
    })
    const chartData = {
      label: "Financements perçus par stade totaux",
      labels: this.data.map(data_of_year => data_of_year.year),
      datasets: [
          {
          label: "Total financements percus",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_percu / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[0]
        },
        {
          label: "Total Financements demandés",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_demande / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[1]
        },
        {
          label: "Total Reste à Demander Notifié",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_reste_a_demander_notifie / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: SOLUTIA[2]
        },
          {
          label: "Total Reste à Demander Non Notifié",
          data: this.data.map(data_of_year => Math.round(data_of_year.total_reste_a_demander_non_notifie / 1000)),
          datalabels: {
            color: '#ffffff',
            font: {
              size: 16
            }
          },
          backgroundColor: "#800020"
        },
          {
          label: "TOTAL",
          tooltip: {
            enabled: false
          },
          data: this.data.map((data_of_year) => arrondirKeurosAsNumber(data_of_year.total_financements / 20)),
          datalabels: {
            color: 'black',
            clamp: true,
            anchor: "end",
            formatter: function (value, context) {
              return arrondirKeuros(that.data[context.dataIndex].total_financements);
            },
            font: {
              size: 16,
              weight: "bold"
            }
          },
          backgroundColor: "#ffffff00"
        },
      ],
    }
    // eslint-disable-next-line no-unused-vars
    const config = {
      title: {
        display: true,
        text: "Financements perçus par stade totaux",
        fontSize: 16,
      },
      legend: {
        display: false,
      },
      scales: {
        yAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            drawBorder: false,
          }
        }],
        xAxes: [{
          stacked: true,
          gridLines: {
            display: false,
          }
        }]
      },

    }
    let that = this;
    this.$nextTick(function () {
      const ctx = document.getElementById('financements-percus-total-par-stade-graph');
      that.chart = new Chart(ctx, {
        plugins: [ChartDataLabels],
        type: "bar",
        //...defaultData
        data: chartData,
        options: config,
      });
    })
  },
  data: function () {
    return {
      chart: null
    }
  },
  computed: {
    statuts() {
      return this.$store.getters["dossier/statuts/statuts"];
    },
  },
  methods: {}
}
</script>

<style scoped>

</style>